/* eslint-disable no-lonely-if */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable indent */
import './style.scss';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import SearchFilters from 'features/SubmitProjectProposal/components/SearchFilters';
import { totalExpenditureSchema } from 'features/ReviseProjectProposal/validation';
import Pagination from 'components/Pagination';
import ErrorDialog from 'components/ErrorDialog';
import { AbilityContext, Can } from 'components/Can';
import useSelectionProject from 'utils/hooks/useSelectionProject';

import { getAllByUser as getAllOrganizationsByUser } from 'apis/organizations.api';
import { deleteProject, exportExcel, getAllProject, restoreProject } from 'apis/projects.api';
import { getAllResearchFieldsByUserId } from 'apis/researchFields.api';
import { getAll as getAllPrograms } from 'apis/programs.api';
import { PROJECT_NEW_STATUSES, TIMEZONE_VN } from 'constant';
import Project from 'constant/project.constant';
import MidtermDocumentDialog from 'features/SubmitProjectProposal/components/ViewList/MidtermDocumentDialog';
import {
  addDefaultProjectStatusToFilter,
  checkIsAllowedCRUDCouncil,
  checkIsAllowedCRUDFromContract,
  getRoles,
  handleEnterKeyPress,
  mapError,
  sanitizeObject,
} from 'utils/func';
import Confirm from 'features/SubmitProjectProposal/components/Confirm';
import { statusColors } from 'utils/func/dashboard';
import ViewHistory from 'features/ReviseProjectProposal/components/ViewHistory';
import { useGetProjectLogs } from 'utils/hooks/projectProposals';

function SubmitProjectProposalViewList() {
  // #region data
  const { t } = useTranslation();
  const roles = getRoles();

  const location = useLocation();
  const [searchParams] = useSearchParams({ replace: true });
  const approvalMenu = useRef(null);
  const dialogConfirmRef = useRef(null);

  const [pagination, setPagination] = useState({
    first: parseInt(searchParams.get('first'), 10) || 0,
    rowsPerPage: 10,
  });
  const [showMode, setShowMode] = useState('hideDeletedProjects');

  const [projectLogsId, setProjectLogsId] = useState(null);
  const [viewHistoryVisible, setViewHistoryVisible] = useState(false);

  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const ability = useContext(AbilityContext);
  const [isVisibleSearchFilters, setIsVisibleSearchFilters] = useState(false);
  const [isLoadedFilterFromLocalStorage, setIsLoadedFilterFromLocalStorage] = useState(false);
  const [filtersTable, setFiltersTable] = useState({
    _vietnameseName: { value: null },
    _projectType: { value: null },
    _ownerName: { value: null },
    _organization: { value: null },
    _yearProposed: { value: null },
    _researchField: { value: null },
    _researchType: { value: null },
    _totalExpenditure: { value: null },
    _program: { value: null },
    _submittedAt: { value: null },
    _councilType: { value: null },
    _status: { value: null },
    _summaryReportFilter: { value: null },
    _hasRegisterResult: { value: null },
  });

  // background filters, sync with localStorage
  const [filters, setFilters] = useState({
    vietnameseName: null,
    projectType: null,
    ownerName: null,
    organizationId: null,
    yearProposed: null,
    researchFieldId: null,
    researchTypeId: null,
    totalExpenditure: { min: null, max: null },
    programId: null,
    submittedAt: { start: null, end: null },
    councilTypeId: null,
    projectStatus: null,
    summaryReportFilter: null,
    hasRegisterResult: null,
  });

  // applied filters, change every time click on Apply and Clear button for update
  const [appliedFilters, setAppliedFilters] = useState({
    vietnameseName: null,
    projectType: null,
    ownerName: null,
    organizationId: null,
    yearProposed: null,
    researchFieldId: null,
    researchTypeId: null,
    totalExpenditure: { min: null, max: null },
    programId: null,
    submittedAt: { start: null, end: null },
    councilTypeId: null,
    projectStatus: null,
    summaryReportFilter: null,
    hasRegisterResult: null,
  });

  const {
    data: _data,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(
    ['projectsSubmitted', pagination, appliedFilters, showMode],
    ({ queryKey: [, _pagination, _filters, _showMode] }) => {
      const queries = {
        ..._filters,
        projectStatus: addDefaultProjectStatusToFilter(_filters.projectStatus),
      };

      return getAllProject(_pagination, sanitizeObject(queries), _showMode);
    },
    {
      enabled: isLoadedFilterFromLocalStorage,
    }
  );

  const data = useMemo(
    () => _data?.data ?? { data: [], pagination: { row: 10, totalRecords: 0 } },
    [_data]
  );

  const { data: organizationsData } = useQuery(
    ['propjectProposalOrganizations'],
    getAllOrganizationsByUser
  );

  const organizations = useMemo(
    () =>
      organizationsData?.data?.map((e) => ({
        id: e?.id,
        name: t('lang') === 'vi' ? e?.name : e?.englishName,
      })) ?? [],
    [organizationsData, t]
  );

  const yearProposedOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= 2019; i -= 1) {
      years.push({ value: i });
    }
    return years;
  }, []);

  const { data: researchFieldsData } = useQuery(
    ['projectProposalResearchFieldsByUserId'],
    getAllResearchFieldsByUserId
  );
  const researchFields = useMemo(
    () =>
      researchFieldsData?.data.map((e) => ({
        id: e.id,
        name: e?.code ? t(`researchFields.${e.code}`) : e.name,
      })) ?? [],
    [researchFieldsData, t]
  );

  const { data: programData } = useQuery(['program'], getAllPrograms);
  const programs = useMemo(() => programData?.data ?? [], [programData]);

  const { data: projectHistory } = useGetProjectLogs(projectLogsId, { enabled: !!projectLogsId });

  const statusOptions = useMemo(
    () =>
      Object.values(PROJECT_NEW_STATUSES).map((status) => ({
        code: status,
        name: t(`projectNewStatuses.${status}`),
      })),
    [t]
  );

  const midtermSummaryReportFilters = useMemo(() => {
    const summaryReportFilterMap = Project.SummaryReportFilters.map((e) => ({
      code: e.code,
      name: t(`summaryReportFilter.${e.code}`),
    }));
    return summaryReportFilterMap;
  }, [t]);

  const { mutate: mutateDeleteProject } = useMutation(deleteProject);
  const { mutate: mutateRestoreProject } = useMutation(restoreProject);

  const {
    mutate: mutateExportExcel,
    isLoading: isExportExcelLoading,
    isError: isExportExcelError,
    error: exportExcelError,
  } = useMutation(exportExcel);

  const {
    selectedItems,
    // eslint-disable-next-line no-unused-vars
    unselectedItems,
    isSelectedAll,
    isUnselectedSome,
    handleAllRowSelect,
    handleAllRowUnselect,
    handleRowSelect,
    handleRowUnselect,
  } = useSelectionProject(data, pagination);

  const approvalItems = [
    {
      label: t('projectProposal.viewList.approve'),
      icon: 'pi pi-check',
      command: () => {},
    },
    { separator: true },
    {
      label: t('projectProposal.viewList.changeRequest'),
      icon: 'pi pi-refresh',
      command: () => {},
    },
  ];

  // #endregion Data

  // #region Event
  useEffect(() => {
    setShowMode(showMode);
  }, [t]);

  useEffect(() => {
    const localFilters = JSON.parse(
      localStorage.getItem(`admin-${location.pathname.slice(1)}-filters`) ?? '{}'
    );
    const localRowsPerPage = parseInt(
      localStorage.getItem(`admin-${location.pathname.slice(1)}-rowsPerPage`),
      10
    );
    const projectStatus = localFilters?.projectStatus ?? [];
    const totalExpenditure = localFilters?.totalExpenditure ?? { min: null, max: null };
    const summaryReportFilter = localFilters?.summaryReportFilter ?? null;

    setFilters({
      ...localFilters,
      projectStatus,
      totalExpenditure,
      summaryReportFilter,
    });
    setAppliedFilters({
      ...localFilters,
      projectStatus,
      totalExpenditure,
      summaryReportFilter,
    });
    setFiltersTable((prev) => ({
      ...prev,
    }));

    if (localRowsPerPage) {
      setPagination((cur) => ({ ...cur, rowsPerPage: localRowsPerPage }));
    }

    // Set current page (first) with searchParams
    const currentFirst = parseInt(searchParams.get('first'), 10) || 0;
    setPagination((cur) => ({ ...cur, first: currentFirst }));
    setIsLoadedFilterFromLocalStorage(true);
  }, []);
  // #endregion Event

  const handleExportExcel = () => {
    // Call api export excel
    // param:selectedItems,unselectedItems,isSelectedAll,isUnselectedSome,researchFieldId,statusName
    mutateExportExcel(
      {
        selectedItems: selectedItems.map((e) => e.projectProposalId),
        unselectedItems: unselectedItems.map((e) => e.projectProposalId),
        isSelectedAll,
        isUnselectedSome,
        ...filters,
      },
      {
        onSuccess: (res) => {
          if (res?.data) {
            const file = new Blob([res.data]);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = 'Danh sach hop dong.xlsx';

            link.click();
          }
          handleAllRowUnselect();
        },
        onError: () => {
          setIsErrorDialogOpen(true);
        },
      }
    );
  };

  // #region Render
  const isRowSelectable = () => true;

  const rowClassName = () => '';

  const formatName = (value) => (
    <>
      <Tooltip target=".project-name-tooltip" />
      <Link
        to={`/projects-submit/${value?.id}/${value?.projectProposal?.reference}/sum-up`}
        className="hover:underline project-name-tooltip"
        data-pr-tooltip={t('contract.viewList.actions.sumUp')}
      >
        {value?.projectProposal?.vietnameseName}
      </Link>
    </>
  );

  const vietnameseNameFilter = () => (
    <InputText
      value={filters.vietnameseName}
      onChange={(e) => {
        const newFilters = { ...filters, vietnameseName: e.target.value };
        setFilters(newFilters);
      }}
      placeholder={t('projectProposal.viewList.name')}
      className="p-column-filter"
      onKeyDown={(e) => {
        handleEnterKeyPress(e, () => {
          setAppliedFilters(filters);
        });
      }}
    />
  );
  const totalExpenditureFilter = () => (
    <div>
      <div className="flex align-items-center mb-2">
        <span className="w-3">{t('projectProposal.viewList.from')}</span>
        <InputNumber
          value={filters?.totalExpenditure?.min ?? undefined}
          onChange={(e) => {
            const newFilters = {
              ...filters,
              totalExpenditure: { ...filters.totalExpenditure, min: e.value },
            };
            setFilters(newFilters);
          }}
          className={classNames('currency', {
            'p-invalid': !totalExpenditureSchema.isValidSync({
              min: filters?.totalExpenditure?.min ?? undefined,
              max: filters?.totalExpenditure?.max ?? undefined,
            }),
          })}
          tooltip={
            !totalExpenditureSchema.isValidSync({
              min: filters?.totalExpenditure?.min ?? undefined,
              max: filters?.totalExpenditure?.max ?? undefined,
            })
              ? t('projectProposal.viewList.validation.min')
              : ''
          }
          tooltipOptions={{ position: 'bottom' }}
          mode="currency"
          currency="VND"
          locale="vi-VN"
          useGrouping
        />
      </div>
      <div className="flex align-items-center">
        <span className="w-3">{t('projectProposal.viewList.to')}</span>
        <InputNumber
          value={filters?.totalExpenditure?.max ?? undefined}
          onChange={(e) => {
            const newFilters = {
              ...filters,
              totalExpenditure: { ...filters.totalExpenditure, max: e.value },
            };
            setFilters(newFilters);
          }}
          className={classNames('currency', {
            'p-invalid': !totalExpenditureSchema.isValidSync({
              min: filters?.totalExpenditure?.min ?? undefined,
              max: filters?.totalExpenditure?.max ?? undefined,
            }),
          })}
          tooltip={
            !totalExpenditureSchema.isValidSync({
              min: filters?.totalExpenditure?.min ?? undefined,
              max: filters?.totalExpenditure?.max ?? undefined,
            })
              ? t('projectProposal.viewList.validation.max')
              : ''
          }
          tooltipOptions={{ position: 'bottom' }}
          mode="currency"
          currency="VND"
          locale="vi-VN"
          useGrouping
        />
      </div>
    </div>
  );

  const formatOwner = (value) => {
    const owner = value?.projectProposal?.projectProposalContacts.find(
      (contact) => contact?.projectRole?.code === 'OWNER'
    );
    if (owner) return <div>{owner.fullname}</div>;
    return null;
  };

  const ownerNameFilter = () => (
    <InputText
      value={filters.ownerName}
      onChange={(e) => {
        const newFilters = { ...filters, ownerName: e.target.value };
        setFilters(newFilters);
      }}
      placeholder={t('projectProposal.viewList.owner')}
      className="p-column-filter"
    />
  );

  const formatOrganization = (value) =>
    t('lang') === 'vi'
      ? value?.projectProposal?.projectProposalOrganizations.filter(
          (ppo) => ppo.type === 'LEAD'
        )?.[0]?.name
      : value?.projectProposal?.projectProposalOrganizations.filter(
          (ppo) => ppo.type === 'LEAD'
        )?.[0]?.englishName;

  const organizationFilter = () => (
    <MultiSelect
      value={filters.organizationId}
      onChange={(e) => {
        const newFilters = { ...filters, organizationId: e.value };
        setFilters(newFilters);
      }}
      options={organizations}
      optionLabel="name"
      optionValue="id"
      filter
      showClear
      placeholder={t('projectProposal.viewList.organization')}
      maxSelectedLabels={3}
      style={{ maxWidth: '22rem', width: '18.5rem' }}
    />
  );

  const yearProposedFilter = () => (
    <MultiSelect
      value={filters.yearProposed}
      onChange={(e) => {
        const newFilters = { ...filters, yearProposed: e.value };
        setFilters(newFilters);
      }}
      options={yearProposedOptions}
      optionLabel="value"
      optionValue="value"
      filter
      showClear
      placeholder={t('projectProposal.general.researchTime.yearProposed')}
      maxSelectedLabels={3}
      style={{ maxWidth: '22rem', width: '18.5rem' }}
    />
  );

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString('en-GB', { timeZone: TIMEZONE_VN }) : '';

  // const formatSubmittedAt = (value) => formatDate(value?.projectProposal?.submittedAt);

  const formatStartDate = (value) => formatDate(value?.startDate);

  const formatEndDate = (value) => formatDate(value?.endDate);

  const formatResearchFields = (value) => (
    <div>
      {value?.projectProposal?.projectProposalResearchFields
        ?.sort((a, b) => {
          if (a.priority === null) return 1;
          if (b.priority === null) return -1;
          if (a.priority === b) return 0;
          return a.priority < b.priority ? -1 : 1;
        })
        ?.map((researchField, index) => (
          <p key={researchField.researchField.id} className="text-left m-0">
            {`(${researchField?.priority ?? index + 1}) ${t(
              `researchFields.${researchField.researchField.code}`
            )}`}
          </p>
        ))}
    </div>
  );
  const researchFieldFilter = () => (
    <MultiSelect
      value={filters.researchFieldId}
      onChange={(e) => {
        const newFilters = { ...filters, researchFieldId: e.value };
        setFilters(newFilters);
      }}
      options={researchFields}
      optionLabel="name"
      optionValue="id"
      filter
      showClear
      placeholder={t('projectProposal.viewList.researchField')}
      maxSelectedLabels={3}
      style={{ maxWidth: '22rem', width: '18.5rem' }}
    />
  );

  const formatTotalExpenditure = (value) => {
    if (value?.totalExpenditure === 0 && value?.proposedExpenditureSummaries?.length > 0) {
      const total = value?.proposedExpenditureSummaries.reduce((sum, cur) => {
        if (cur?.proposedExpenditureType?.subProposedExpenditureTypeId === null) {
          const expenditureFromFunding = cur?.expenditureFromFunding ?? 0;
          const expenditureFromVNUHCM = cur?.expenditureFromVNUHCM ?? 0;

          return sum + expenditureFromFunding + expenditureFromVNUHCM;
        }
        return sum;
      }, 0);
      return ((total || 0) / 1000000).toLocaleString('vi');
    }
    return ((value?.totalExpenditure || 0) / 1000000)?.toLocaleString('vi');
  };

  const formatStatus = (value) => {
    const status = value.dashboardStatus;

    return (
      <Tag
        style={{
          maxWidth: '8rem',
          backgroundColor: statusColors.submit[status],
          color: '#ffffff',
        }}
        value={t(`projectNewStatuses.${status}`)}
        rounded
      />
    );
  };

  const formatActions = (value) => {
    const menuRef = useRef(null);

    const items = [];

    if (value?.deletedAt === null) {
      // Cập nhật hợp đồng
      if (ability.can('read_detail', 'project')) {
        items.push({
          template: () => (
            <Link
              to={`/projects-submit/create/${value.projectProposal.id}`}
              className="p-menuitem-link"
            >
              <span className="p-menuitem-text">{t('contract.update')}</span>
            </Link>
          ),
        });
      }

      // Xem đề tài
      if (ability.can('read', 'project_proposal')) {
        items.push({
          template: () => (
            <Link
              to={`/projects-submit/${value?.projectProposal?.reference}`}
              state={{
                projectId: value?.id,
              }}
              className="p-menuitem-link"
            >
              <span className="p-menuitem-text">
                {t('contract.viewList.actions.reviewTheProposal')}
              </span>
            </Link>
          ),
        });
      }

      // Xem lịch sử trạng thái của đề tài
      if (ability.can('read', 'project_proposal')) {
        items.push({
          label: t('projectProposal.viewList.tooltip.viewHistory'),
          command: () => {
            setProjectLogsId(value?.projectProposal?.id ?? '');
            setViewHistoryVisible(true);
          },
        });
      }

      if (checkIsAllowedCRUDFromContract(value?.projectProposal?.projectType, roles)) {
        // Acceptance summary report
        if (ability.can('read', 'summary-report')) {
          if (value?.acceptanceSummaryReport) {
            items.push({
              template: () => (
                <Link
                  to={`/projects-submit/${value?.id}/${value?.projectProposal?.reference}/${value?.acceptanceSummaryReport?.id}/acceptance-document?tab=1`}
                  className="p-menuitem-link"
                >
                  <span className="p-menuitem-text">
                    {t('projectProposal.viewList.acceptanceDocument')}
                  </span>
                </Link>
              ),
            });
          }
        }

        // Liquidation Council
        if (
          checkIsAllowedCRUDCouncil(value?.projectProposal?.projectType, roles, {
            institutionalSetting: [],
          }) &&
          ability.can('read', 'summary-report')
        ) {
          if (value?.liquidationSummaryReport) {
            items.push({
              template: () => (
                <Link
                  to={`/projects-submit/${value?.id}/${value?.projectProposal?.reference}/${value?.liquidationSummaryReport?.id}/liquidation-document?tab=1`}
                  className="p-menuitem-link"
                >
                  <span className="p-menuitem-text">{t('liquidationCouncil.button')}</span>
                </Link>
              ),
            });
          }
        }

        // Check Result
        if (value?.registerResults?.length > 0 && ability.can('read', 'register-result')) {
          items.push({
            template: () => (
              <Link
                to={`/projects-submit/${value?.id}/register-result-checker${
                  value?.liquidationStatus === 'qualified' ? '-liquidation' : ''
                }`}
                className="p-menuitem-link"
              >
                <span className="p-menuitem-text">{t('registerResult.action.view')}</span>
              </Link>
            ),
          });
        }

        // Xem yêu cầu điều chỉnh
        if (ability.can('read', 'financial_adjustment')) {
          items.push({
            template: () => (
              <Link
                to={`/projects-submit/${value?.id}/project-adjustment`}
                className="p-menuitem-link"
              >
                <span className="p-menuitem-text">
                  {t('projectProposal.viewList.viewAdjustment')}
                </span>
                {value.newAdjustments > 0 && (
                  <>
                    <span
                      className="new-adjustments-badge"
                      style={{
                        marginLeft: '8px',
                        backgroundColor: '#ef4444',
                        color: 'white',
                        borderRadius: '50%',
                        padding: '2px 6px',
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                      }}
                    >
                      {value.newAdjustments}
                    </span>
                  </>
                )}
              </Link>
            ),
          });
        }

        // Xóa hợp đồng
        if (ability.can('delete', 'project')) {
          items.push({
            label: t('project.viewList.delete'),
            command: () => {
              dialogConfirmRef.current.open({
                mode: 'delete',
                mutate: mutateDeleteProject,
                value,
              });
            },
          });
        }
      }
    } else {
      // Khôi phục hợp đồng
      if (ability.can('restore', 'project_proposal')) {
        items.push({
          label: t('project.viewList.restore'),
          command: () => {
            dialogConfirmRef.current.open({
              mode: 'restore',
              mutate: mutateRestoreProject,
              value,
            });
          },
        });
      }
    }

    const hasAdjustments = value?.deletedAt === null && value.newAdjustments > 0;

    return (
      <div className="flex justify-content-center">
        <Menu model={items} popup ref={menuRef} style={{ minWidth: '250px' }} />
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <Button
            icon="pi pi-ellipsis-v"
            className="p-button-rounded p-button-text"
            onClick={(event) => menuRef.current.toggle(event)}
          />
          {hasAdjustments && (
            <Badge
              severity="danger"
              style={{
                position: 'absolute',
                top: '-2px',
                right: '-2px',
                minWidth: '0.5rem',
                height: '0.5rem',
                fontSize: '0.5rem',
                padding: '0',
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const formatActionMidtermDocument = (value) => {
    const isHadMidtermDocument = value?.midtermSummaryReports?.length > 0;
    //  count number key council=null in midtermSummaryReports
    const midtermCouncilCount = useMemo(
      () =>
        value?.midtermSummaryReports?.filter((midtermDocument) => midtermDocument?.council === null)
          .length,
      [value?.midtermSummaryReports]
    );
    const [isVisibleMidtermListDialog, setIsVisibleMidtermListDialog] = useState(false);
    return checkIsAllowedCRUDFromContract(value?.projectProposal?.projectType, roles) ? (
      <div className="flex justify-content-center align-items-center gap-1 ">
        <div className="button-midterm-document-container">
          {isHadMidtermDocument && (
            <Button
              className="button-midterm-document"
              icon="pi pi-book"
              onClick={() => setIsVisibleMidtermListDialog(true)}
              severity="success"
              style={{ width: '42px', height: '42px' }}
              tooltip={
                isHadMidtermDocument
                  ? t('projectProposal.viewList.midtermDocument')
                  : t('projectProposal.viewList.noMidtermDocument')
              }
              tooltipOptions={{ position: 'left' }}
            />
          )}
          {!isHadMidtermDocument && (
            <Button
              className="button-midterm-document cursor-auto"
              icon="pi pi-book"
              severity="secondary"
              style={{ width: '42px', height: '42px' }}
              tooltip={
                isHadMidtermDocument
                  ? t('projectProposal.viewList.midtermDocument')
                  : t('projectProposal.viewList.noMidtermDocument')
              }
              tooltipOptions={{ position: 'left' }}
            />
          )}
          {midtermCouncilCount > 0 && (
            <>
              <span className="midterm-document-count">{midtermCouncilCount}</span>
              <Tooltip
                target=".midterm-document-count"
                mouseTrack
                mouseTrackLeft={10}
                content={t('projectProposal.viewList.tooltip.midtermReportNo')}
              />
            </>
          )}
          <MidtermDocumentDialog
            projectId={value?.id}
            projectProposalId={value?.projectProposal?.reference}
            midtermDocuments={value?.midtermSummaryReports}
            visible={isVisibleMidtermListDialog}
            setVisible={setIsVisibleMidtermListDialog}
          />
        </div>
      </div>
    ) : (
      <div />
    );
  };

  const statusFilter = () => (
    <MultiSelect
      value={filters.projectStatus}
      options={statusOptions}
      onChange={(e) => {
        const hasRegisterResult =
          e.value && e.value.includes(PROJECT_NEW_STATUSES.HAS_REGISTER_RESULT);
        const newFilters = {
          ...filters,
          projectStatus: e.value,
          hasRegisterResult,
        };
        setFilters(newFilters);
      }}
      optionLabel="name"
      optionValue="code"
      showClear
      filter
      placeholder={t('projectProposal.viewList.status')}
      style={{ minWidth: '12rem' }}
      maxSelectedLabels={3}
    />
  );

  const programTemplate = (option) => (
    <div
      className="text-overflow-ellipsis w-26rem overflow-hidden program-filter-list"
      data-pr-tooltip={option.name}
      data-pr-position="right"
      data-pr-at="right+5 top"
      data-pr-my="left center-2"
    >
      {option.name}
      <Tooltip target=".program-filter-list" />
    </div>
  );

  const programFilter = () => (
    <MultiSelect
      value={filters.programId}
      onChange={(e) => {
        const newFilters = { ...filters, programId: e.value };
        setFilters(newFilters);
      }}
      options={programs}
      optionLabel="name"
      optionValue="id"
      optionGroupChildren="children"
      filter
      showClear
      placeholder={t('projectProposal.viewList.program')}
      style={{ maxWidth: '22rem', width: '18.5rem' }}
      panelStyle={{ maxWidth: '30rem', width: '30rem' }}
      emptyMessage={t('program.viewList.emptyMessage')}
      emptyFilterMessage={t('program.viewList.emptyMessageFilter')}
      title={t('program.viewList.title')}
      itemTemplate={programTemplate}
    />
  );

  const midtermSummaryReportFilter = () => (
    <Dropdown
      value={filters.summaryReportFilter}
      optionValue="code"
      optionLabel="name"
      options={midtermSummaryReportFilters}
      onChange={(e) => {
        const newFilters = { ...filters, summaryReportFilter: e.value };
        setFilters(newFilters);
      }}
      showClear
      filter
      placeholder={t('summaryReportFilter.ever')}
    />
  );

  const filterClearTemplate = (options) => (
    <Button
      type="button"
      label={t('employee.viewList.clear')}
      onClick={() => {
        handleAllRowUnselect();
        options.filterClearCallback();
      }}
      severity="secondary"
      outlined
    />
  );

  const filterApplyTemplate = (options) => (
    <Button
      type="button"
      label={t('employee.viewList.apply')}
      onClick={() => {
        handleAllRowUnselect();
        options.filterApplyCallback();
        localStorage.setItem(
          `admin-${location.pathname.slice(1)}-filters`,
          JSON.stringify(filters)
        );
      }}
      disabled={
        !totalExpenditureSchema.isValidSync({
          min: filters?.totalExpenditure?.min ?? undefined,
          max: filters?.totalExpenditure?.max ?? undefined,
        })
      }
      severity="success"
    />
  );

  const filterActiveStyle = (field) =>
    filters[field] && (filters[field]?.length > 0 || Object.values(filters[field]).some((e) => e))
      ? { color: '#22C55E' }
      : { color: '#6c757d' };

  const renderHeader = () => (
    <div className="flex justify-content-between">
      <Button
        type="button"
        icon="pi pi-filter"
        label={t('projectProposal.viewList.searchFilters')}
        outlined
        onClick={() => setIsVisibleSearchFilters(true)}
      />
    </div>
  );
  // #region Return
  return (
    <div className="card relative">
      {isError && <h3 className="text-red-600">{mapError(t, error)}</h3>}

      <div className="flex align-items-center justify-content-between gap-2 pb-4">
        <h4 className="m-0 hidden sm:block text-xl sm:text-2xl">
          {t('projectProposal.viewList.title')}
        </h4>
        <div className="flex gap-2">
          <Can do="export_excel" on="project_proposal">
            <div>
              <Button
                type="button"
                label={t('projectProposal.viewList.tooltip.excel')}
                icon={classNames(
                  'pi',
                  { 'pi-spin pi-spinner': isExportExcelLoading },
                  { 'pi-file-excel': !isExportExcelLoading }
                )}
                severity="success"
                onClick={handleExportExcel}
                disabled={
                  (!isSelectedAll && !isUnselectedSome && !selectedItems.length) ||
                  isExportExcelLoading
                }
              />
            </div>
          </Can>
        </div>
      </div>

      {!isLoading && data?.data?.length ? (
        <Checkbox
          style={{ position: 'absolute', top: '192px', left: '43px', zIndex: 10 }}
          checked={isSelectedAll}
          onChange={() => (!isSelectedAll ? handleAllRowSelect() : handleAllRowUnselect())}
        />
      ) : null}

      <DataTable
        value={data?.data}
        className="project-list"
        dataKey="projectProposalId"
        header={renderHeader}
        showGridlines
        scrollable
        selection={selectedItems}
        selectionMode="multiple"
        showSelectAll={false}
        onRowSelect={handleRowSelect}
        onRowUnselect={handleRowUnselect}
        isDataSelectable={isRowSelectable}
        rowClassName={rowClassName}
        loading={isLoading}
        emptyMessage={t('projectProposal.viewList.emptyMessage')}
        filters={filtersTable}
        onFilter={(e) => setFiltersTable(e.filters)}
        filterDisplay="menu"
      >
        {ability.can('export_excel', 'project_proposal') ? (
          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} frozen />
        ) : null}
        <Column
          header={t('projectProposal.viewList.name')}
          headerStyle={filterActiveStyle('vietnameseName')}
          body={formatName}
          filter
          filterField="_vietnameseName"
          filterElement={vietnameseNameFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMenu
          showFilterMatchModes={false}
          onFilterClear={() => {
            const newFilters = { ...filters, vietnameseName: '' };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '10rem', maxWidth: '16rem', textAlign: 'center', color: '#6366F1' }}
          frozen
          alignFrozen="left"
        />
        <Column
          header={t('projectProposal.viewList.owner')}
          headerStyle={{ ...filterActiveStyle('ownerName'), justifyContent: 'center' }}
          body={formatOwner}
          filter
          filterField="_ownerName"
          filterElement={ownerNameFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMenu
          showFilterMatchModes={false}
          onFilterClear={() => {
            const newFilters = { ...filters, ownerName: '' };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '8rem', textAlign: 'center' }}
        />
        <Column
          header={t('projectProposal.viewList.organization')}
          headerStyle={{ ...filterActiveStyle('organizationId'), justifyContent: 'center' }}
          body={formatOrganization}
          filter
          filterField="_organization"
          filterElement={organizationFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu={organizations?.length > 1}
          onFilterClear={() => {
            const newFilters = { ...filters, organizationId: [] };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '8rem', textAlign: 'center' }}
        />
        <Column
          header={t('projectProposal.general.researchTime.yearProposed')}
          headerStyle={{ ...filterActiveStyle('yearProposed'), justifyContent: 'center' }}
          field="projectProposal.yearProposed"
          filter
          filterField="_yearProposed"
          filterElement={yearProposedFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu
          onFilterClear={() => {
            const newFilters = { ...filters, yearProposed: [] };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '8rem', textAlign: 'center' }}
        />
        <Column
          header={t('projectProposal.viewList.researchField')}
          headerStyle={{ ...filterActiveStyle('researchFieldId'), justifyContent: 'center' }}
          body={formatResearchFields}
          filter
          filterField="_researchField"
          filterElement={researchFieldFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu
          onFilterClear={() => {
            const newFilters = { ...filters, researchFieldId: [] };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '10rem', textAlign: 'center' }}
        />
        <Column
          field="projectProposal.program.name"
          header={t('projectProposal.viewList.program')}
          headerStyle={filterActiveStyle('programId')}
          filter
          filterField="_program"
          filterElement={programFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu
          onFilterClear={() => {
            const newFilters = { ...filters, programId: [] };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
          style={{ minWidth: '8rem' }}
        />
        <Column
          header={
            <span style={{ whiteSpace: 'pre-line' }}>
              {t('projectProposal.viewList.totalExpenditure')}
            </span>
          }
          headerStyle={{ ...filterActiveStyle('totalExpenditure'), justifyContent: 'center' }}
          body={formatTotalExpenditure}
          dataType="numeric"
          style={{ minWidth: '9rem', textAlign: 'center' }}
          filter
          filterField="_totalExpenditure"
          filterElement={totalExpenditureFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMenu
          showFilterMatchModes={false}
          onFilterClear={() => {
            const newFilters = { ...filters, totalExpenditure: { min: null, max: null } };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
        />
        <Column
          header={t('projectProposal.viewList.status')}
          headerStyle={filterActiveStyle('projectStatus')}
          body={formatStatus}
          style={{ minWidth: '8rem', textAlign: 'center' }}
          filter
          filterField="_status"
          filterElement={statusFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu
          onFilterClear={() => {
            const newFilters = {
              ...filters,
              projectStatus: [],
              hasRegisterResult: null,
            };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
          }}
        />
        <Column
          header={t('projectProposal.viewList.startDate')}
          style={{ minWidth: '8rem' }}
          body={formatStartDate}
          dataType="date"
        />
        <Column
          header={t('projectProposal.viewList.endDate')}
          style={{ minWidth: '8rem' }}
          body={formatEndDate}
          dataType="date"
        />

        <Column
          header={t('projectProposal.viewList.midtermDocument')}
          body={formatActionMidtermDocument}
          style={{ minWidth: '7rem', textAlign: 'center' }}
          filter
          filterField="_summaryReportFilter"
          filterElement={midtermSummaryReportFilter}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          showFilterMatchModes={false}
          showFilterMenu
          onFilterClear={() => {
            const newFilters = { ...filters, summaryReportFilter: null };
            setFilters(newFilters);
            setAppliedFilters(newFilters);
            setFiltersTable((prev) => ({
              ...prev,
              _summaryReportFilter: { value: null },
            }));
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(newFilters)
            );
          }}
          onFilterApplyClick={() => {
            setAppliedFilters(filters);
            setFiltersTable((prev) => ({
              ...prev,
              _summaryReportFilter: { value: filters.summaryReportFilter },
            }));
            localStorage.setItem(
              `admin-${location.pathname.slice(1)}-filters`,
              JSON.stringify(filters)
            );
          }}
          frozen
          alignFrozen="right"
        />
        <Column
          header={t('projectProposal.action')}
          style={{ minWidth: '6rem', maxWidth: '12rem', textAlign: 'center' }}
          body={formatActions}
          frozen
          alignFrozen="right"
        />
      </DataTable>

      <Pagination
        pagination={pagination}
        setPagination={setPagination}
        paginationData={data.pagination}
        showMode={showMode}
        setShowMode={setShowMode}
        pageName="projects-submit"
      />

      {isVisibleSearchFilters && (
        <SearchFilters
          visible={isVisibleSearchFilters}
          setVisible={setIsVisibleSearchFilters}
          filters={filters}
          setFilters={setFilters}
          appliedFilters={appliedFilters ?? {}}
          setAppliedFilters={setAppliedFilters}
          organizations={organizations}
          programs={programs}
          statuses={statusOptions}
        />
      )}

      <Menu model={approvalItems} popup ref={approvalMenu} />

      <ErrorDialog
        title={t('projectProposal.exportExcelErrorTitle')}
        isError={isExportExcelError}
        error={exportExcelError}
        visible={isErrorDialogOpen}
        setVisible={setIsErrorDialogOpen}
      />

      <Confirm ref={dialogConfirmRef} refetch={refetch} />

      <ViewHistory
        data={projectHistory}
        visible={viewHistoryVisible}
        setVisible={setViewHistoryVisible}
      />
    </div>
  );
  // #endregion Render
}

export default SubmitProjectProposalViewList;
